import "./index.css";
import useStore from './store';
import mpData from './data/mp-data-cleaned.json'
import electorates from './data/postcodes-to-electorate.json'
import Fuse from 'fuse.js'
import { useEffect, useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";


function App() {

  const mp = useStore(state => state.mp)
  const setMp = useStore(state => state.setMp)
  const addMp = useStore(state => state.addMp)

  const postcode = useStore(state => state.postcode)
  const setPostcode = useStore(state => state.setPostcode)

  const userEmail = useStore(state => state.userEmail)
  const setUserEmail = useStore(state => state.setUserEmail)

  const fullname = useStore(state => state.fullname)
  const setFullname = useStore(state => state.setFullname)

  const message = useStore(state => state.message)
  const setMessage = useStore(state => state.setMessage)

  const cc = useStore(state => state.cc)
  const setCc = useStore(state => state.setCc)

  const isFormValid = useStore(state => state.isFormValid)
  const setIsFormValid = useStore(state => state.setIsFormValid)

  const initialText = useStore(state => state.initialText)
  const setInitialText = useStore(state => state.setInitialText)

  const closingText = useStore(state => state.closingText)
  const setClosingText = useStore(state => state.setClosingText)

  const combinedText = useStore(state => state.combinedText)
  const setCombinedText = useStore(state => state.setCombinedText)

  const token = useStore(state => state.token)
  const setToken = useStore(state => state.setToken)

  const [isLoading, setIsLoading] = useState(false); // State for loading status

  const onChange = (value) => {
    setToken(value)
  }

  const [checkboxStates, setCheckboxStates] = useState({
    option1: { checked: false, text: "Years of Medicare rebate freezes and inadequate indexation have created significant barriers to accessing affordable GP care. Many Australians are struggling   with increasing out-of-pocket costs, especially when they need to spend more time working through their healthcare needs with their GP and it’s not viable for the service to bulk-billed.\n\nWe need comprehensive reform that ensures all Australians have access to affordable, quality, sustainable primary care.\n\nWhilst the bulk billing incentives will un-doubtly help many vulnerable people, many practices will not all be able to afford to bulk bill and still meet the cost of running their practices.\n\nIt’s time to show leadership. We need to Modernise Medicare today by providing more funding to support GP consultations, particularly longer consultations, to help our GPs provide the comprehensive care that patients with increasingly complex care needs now require." },
    option2: { checked: false, text: "Australia's GP workforce faces a dramatic decline that threatens our community's access to primary care.\n\nThe AMA's plan to Modernise Medicare addresses this crisis by calling for an increase in GP training places while providing equitable employment conditions for GP trainees to encourage more doctors to become a GP.\n\nOur community deserves reliable access to GP care. I urge you to support the call to Modernise Medicare and boost the GP workforce to ensure we have enough GPs to meet our community's needs. " },
    option3: { checked: false, text: "The AMA’s proposed reforms to Medicare to encourage longer consultations would better support the delivery of comprehensive healthcare, particularly for our aging population and those with complex and chronic conditions. This reform would help reduce the number of people delaying GP visits due to cost, ultimately leading to better health outcomes and reduced pressure on our emergency departments. Now is the time to commit to this important reform. \n\nThe AMA is also calling for funding to ensure we create a true medical home — where our GPs work with nurses, mental health professionals, physiotherapists, diabetes educators and other healthcare workers. Supporting a connected healthcare system under one roof would go a long way to improving our healthcare. " },
  });

  // Set initialText and closingText
  useEffect(() => {
    const newInitialText = `Dear MP,\n\nI am writing as your constituent in your electorate about a critical issue: affordable access to GP care. \n\nI support the Australian Medical Association's Modernise Medicare campaign and believe you should too.\n\nWhile recent increases in bulk billing incentives have been a welcome step, they alone cannot address the fundamental challenges facing our primary healthcare system.\n\nMedicare funding arrangements to support patients to access care from a GP are old, out-of-date, and in urgent need of reform.\n\nMedicare no longer provides adequate support for patients with complex conditions or chronic disease.\n\nIt’s time for a comprehensive overhaul that makes Medicare fit-for-purpose — a system that recognises the needs of patients with complex and chronic health concerns.\n\nWe need a system that addresses the future health needs of our country by having enough GPs, working together with our other healthcare providers, to provide patients with access to comprehensive and co-ordinated care.`;
    const newClosingText = `\n\nAs a representative for our community in Parliament, your position on healthcare reform is crucial to me. I urge you to support comprehensive Medicare reform that addresses these critical issues. Our community needs a healthcare system that ensures accessible, affordable, and high-quality primary care for all Australians.\n\nYou can read the AMA's full Modernise Medicare policy brief at ama.com.au/modernise-medicare-policy-brief.\n\nI look forward to receiving a clear response outlining your position on this important issue and the specific actions you will commit to.\n\nYours sincerely,\n\n${fullname}\n${userEmail}`;

    setInitialText(newInitialText);
    setClosingText(newClosingText);
  }, [mp.electorate, fullname, userEmail]);

  // Combine initialText and closingText once
  useEffect(() => {

    let newCombinedText = initialText;

    // Add selected text options
    Object.values(checkboxStates).forEach((option) => {
      if (option.checked) {
        newCombinedText += `\n\n${option.text}\n\n`;
      }
    });

    newCombinedText += closingText;

    setCombinedText(newCombinedText);
  }, [initialText, closingText, checkboxStates]);

  // Handle user input
  const handleTextChange = (e) => {
    const newValue = e.target.value;
    setCombinedText(newValue);
  };

  // Handle checkbox change
  const handleMessageCheckboxChange = (optionKey) => (e) => {
    setCheckboxStates((prevStates) => ({
      ...prevStates,
      [optionKey]: {
        ...prevStates[optionKey],
        checked: e.target.checked,
      },
    }));
  };


  useEffect(() => {
    setIsFormValid(userEmail, mp, fullname, token);
  }, [userEmail, mp, fullname, token]);

  const formRef = useRef(null); // Create a ref for the form

  const fuseOptions = {
    minMatchCharLength: 4,
    threshold: 0.1,
    keys: [
      "postcode"
    ]
  }

  const fuse = new Fuse(electorates, fuseOptions);

  const handleSearch = () => {
    const postcode = document.getElementById('postcode').value
    const result = fuse.search(postcode)

    try {
      if (result.length > 0) {
        result.forEach((item) => {
          console.log(item.item.electorate)
          const electorate = item.item.electorate
          const mp = mpData.find(mp => mp.electorate === electorate)
          addMp(mp)
        });
      } else {
        alert('No MPs found, please check your postcode and try again.')
      }
    } catch (error) {
      alert('There was an error, please try again later.')
      console.log("error")
    }

  }

  const handleReset = () => {
    setPostcode('')
    setMp([])
  }

  // useEffect(() => {
  //   console.log(mp);
  //   console.log(mp.length)
  // }, [mp]);

  const handleCheckboxChange = (event) => {
    setCc(event.target.checked);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSearch(postcode);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // console.log(JSON.stringify(mp))
    setIsLoading(true)

    const data = new URLSearchParams();
    data.append('email', userEmail);
    data.append('mps', JSON.stringify(mp));
    data.append('postcode', postcode);
    data.append('message', combinedText);
    data.append('cc', cc);
    data.append('fullname', fullname);
    data.append('token', token)

    // console.log(data.toString());

    try {
      const response = await fetch('/modernise-medicare/contact-mp', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: data.toString(),
      });

      const result = await response.json();
      // console.log(result);
      formRef.current.reset();

      // Reset state values
      setPostcode('');
      setUserEmail('');
      setFullname('')
      setMessage('');
      setCc(false);
      setMp([]);
      window.grecaptcha.reset();
      document.getElementById("thanks").classList.remove("hidden")
    } catch (error) {
      alert("Something went wrong please try again later.")
      console.error('Error:', error);
    } finally {
      setIsLoading(false)
    }
  };

  const checkMp = () => {
    if (mp.length <= 0) {
      return '';
    } else {
      return mp
        .map((item, index) => {
          if (!item) return undefined;
          return (
            <div key={index} className="flex flex-col bg-tertiary/30 rounded-3xl p-3">
              <div className="flex justify-between">
                <p className="uppercase text-xs font-semibold">{item.electorate}</p>
                <p>{item.party}</p>
              </div>
              <p className="font-bold">{item.firstName} {item.lastName}</p>
              <p>{item.emailAddress}</p>
            </div>
          );
        })
        .filter(Boolean);
    }
  }

  return (
    <div className="App text-left relative">
      <form id="contact-mp" className="text-sm grid md:grid-cols-2 w-full divide-y-[1px] md:divide-y-0 md:divide-x-[1px] divide-black" onSubmit={handleSubmit} ref={formRef}>
        <div className="flex flex-col md:basis-1/2 p-8 space-y-7">
          <h3 class="font-semibold text-base md:text-lg">It takes less than a minute to push your MP to Modernise Medicare today​</h3>
          <p class="text-sm md:text-base font-light">Your voice matters. Tell your MP it's time for change. Send an email today urging them to Modernise Medicare by reforming the MBS items, ensuring all Australians can access the care they deserve.​​</p>
          {/* local mp */}
          <div className="flex flex-col space-y-2">
            <label htmlFor="postcode" className="font-semibold">
              Find your local MP(s)
            </label>
            <div className="w-full flex space-x-2">
              <input
                type="text"
                id="postcode"
                name="postcode"
                value={postcode}
                onChange={(e) => setPostcode(e.target.value)}
                placeholder="Enter your postcode"
                className={`bg-gray-100 p-4 rounded-xl flex-grow ${mp.length > 0 ? 'bg-gray-300 text-gray-400' : 'bg-gray-100'}`}
                maxLength={4}
                disabled={mp.length > 0}
                onKeyDown={handleKeyDown}
              />
              <input
                type="button"
                className={`bg-primary cursor-pointer hover:bg-primary/75 transition-all p-4 rounded-full text-white ${mp.length === 0 ? 'block' : 'hidden'}`}
                onClick={() => handleSearch()}
                value={"Find my MP"}
              />
              <input
                type="button"
                className={`bg-highlight cursor-pointer p-4 rounded-full hover:bg-primary/75 transition-all ${mp.length > 0 ? 'block' : 'hidden'}`}
                onClick={() => handleReset()}
                value={"Reset"}
              />
            </div>
          </div>

          {/* mp value */}
          <div className="space-y-2">{checkMp()}</div>

          {/* full name */}
          <div className="flex flex-col space-y-2">
            <label htmlFor="fullname" className="font-semibold">
              Full name
            </label>
            <div className="w-full flex space-x-2">
              <input
                type="text"
                id="fullname"
                name="fullname"
                onChange={(e) => setFullname(e.target.value)}
                placeholder="Your full name"
                className="bg-gray-100 p-4 rounded-xl flex-grow"
              />
            </div>
          </div>

          {/* email address */}
          <div className="flex flex-col space-y-2">
            <label htmlFor="email" className="font-semibold">
              Email address
            </label>
            <input
              type="email"
              id="email"
              name="email"
              onChange={(e) => {
                setUserEmail(e.target.value)
              }
              }
              placeholder="Your email address"
              className="bg-gray-100 p-4 rounded-xl"
            />
          </div>

          {/* checkboxes */}
          <div className="flex flex-col space-y-2">
            <p className="font-semibold">Craft your email</p>
            <p>Select an option to add it to your email:</p>
            <div className="flex items-center">
              <input
                type="checkbox"
                id="option1"
                name="option1"
                value="Option 1"
                className="mr-2 option"
                checked={checkboxStates.option1.checked}
                onChange={handleMessageCheckboxChange("option1")}
              />
              <label htmlFor="option1">More time</label>
            </div>
            <div className="flex items-center">
              <input
                type="checkbox"
                id="option2"
                name="option2"
                value="Option 2"
                className="mr-2 option"
                checked={checkboxStates.option2.checked}

                onChange={handleMessageCheckboxChange("option2")}
              />
              <label htmlFor="option2">More care</label>
            </div>
            <div className="flex items-center">
              <input
                type="checkbox"
                id="option3"
                name="option3"
                value="Option 3"
                className="mr-2 option"
                checked={checkboxStates.option3.checked}
                onChange={handleMessageCheckboxChange("option3")}
              />
              <label htmlFor="option3">More health</label>
            </div>
          </div>

          {/* cc */}
          <div className="flex flex-col space-y-2">
            <p className="font-semibold">Would you like a response?</p>
            <p>This will CC your email address into the email</p>
            <div className="flex items-center">
              <input type="checkbox" id="cc" name="cc" className="mr-2" checked={cc} onChange={(e) => {
                handleCheckboxChange(e)
              }} />
              <label htmlFor="cc">Yes, I would like to be CC'd</label>
            </div>
          </div>
        </div>
        <div className="flex flex-col md:basis-1/2 p-8 space-y-7">

          {/* message */}
          <div className="flex flex-col flex-grow space-y-2">
            <label htmlFor="message" className="font-semibold">
              Your message
            </label>
            <textarea
              id="message"
              name="message"
              placeholder="Enter your message to your local MP"
              className="bg-gray-100 p-4 rounded-xl h-48 md:flex-grow resize-none"
              onChange={handleTextChange}
              value={combinedText} disabled
            ></textarea>
          </div>

          {/* submit */}
          <div className="mx-auto">
            <ReCAPTCHA
              sitekey="6LdKksgqAAAAAADUs7lupvG2h9A-FXL3m0sbBjRT"
              onChange={onChange}
            />
          </div>
          <input
            type="submit"
            value={mp.length <= 0 ? 'You have not searched for your local MP' : 'Send my message'}
            className={`p-4 rounded-full font-bold w-full cursor-pointer ${isFormValid ? 'bg-primary text-white' : 'bg-gray-200 text-gray-300'} ${isLoading ? 'hidden': 'block'}`}
            disabled={!isFormValid}
          />
          {/* Loading indicator */}
          {isLoading && (
            <div className="loading-overlay flex flex-col items-center align-middle"> {/* Or any other styling you prefer */}
              <div className="loader"></div> {/* You can use a spinner component or image here */}
              <p>Submitting....</p>
            </div>
          )}
        </div>
      </form>
      <div className="text-center hidden p-5 bg-highlight" id="thanks">
        <div className="max-w-2xl mx-auto space-y-4">
          <p className="font-bold" >
            Thank you for standing up for Medicare and all those who rely on it
          </p>
          <p>By emailing your MP, you've taken a powerful step towards reform. Now, let's keep the momentum going — share this cause with your community and networks.</p>
          <p>Together, we can unite as changemakers, amplify our voices, and ensure every Australian gets the care they deserve</p>
          <p>Spread the word on social media and encourage others to join the movement!</p>
        </div>
        <button className="underline text-sm" onClick={() => document.getElementById("thanks").classList.add("hidden")}>Close</button>
      </div>
    </div>
  );
}

export default App;
